const DEFAULT_STATE = {
  loading: false,
  logs: [],
  meta: {},
}

export default function integrationLogsReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {
    case 'INTEGRATION_LOGS_LOAD_PENDING':
      return {
        ...state,
        loading: true,
      }

    case 'INTEGRATION_LOGS_LOAD_REJECTED':
      return {
        ...state,
        loading: false,
        logs: [],
      }

    case 'INTEGRATION_LOGS_LOAD_FULFILLED':
      return {
        ...state,
        loading: false,
        logs: response?.integration_logs || [],
        meta: response?.meta || {},
      }

    default:
      return state
  }
}
